export default __webpack_public_path__ + "static/media/scholarly, casual.2ed52caa.jpg";